var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHide = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-stroke icon-stroke-color-b",
    d: "m21.602 14.531c.887-1.128 1.398-2.105 1.398-2.532 0-1.333-4.925-8-11-8-.294 0-.583.028-.872.058"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-stroke icon-stroke-color-b",
    d: "m2.397 9.468c-.887 1.127-1.397 2.103-1.397 2.531 0 1.333 4.925 8 11 8 .293 0 .581-.028.869-.058"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-stroke icon-stroke-color-a",
    d: "m1 1 22 22"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHide, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hide.6a9fe2e5.svg";
export { ForwardRef as ReactComponent };